module.exports = __webpack_public_path__ + "static/img/gutachten_2.570a392.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/gutachten_2.png
// module id = uYll
// module chunks = 1